module.exports = __webpack_public_path__ + "img/f128bbd1fe1b87ebd8cde48ed8eb7bc.6e500c00.png";